const renderRawHtml = (html) => { return { dangerouslySetInnerHTML: { __html: html } } };
export default renderRawHtml